import React, { createContext, useCallback, useMemo, useState } from 'react';

export type HeaderContextType = {
  isMobileMenuOpen: boolean;
  toggleMobileMenu: () => void;
  mobileMenuActiveItem: string | null;
  toggleMobileMenuActiveItem: (id: string) => void;
};

const HeaderContext = createContext<HeaderContextType>({
  isMobileMenuOpen: false,
  toggleMobileMenu: () => {},
  mobileMenuActiveItem: null,
  toggleMobileMenuActiveItem: () => {},
});

export default HeaderContext;

interface HeaderContextProviderProps {
  children: React.ReactNode;
}

export function HeaderContextProvider({ children }: HeaderContextProviderProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [mobileMenuActiveItem, setMobileMenuActiveItem] = useState<string | null>(null);

  const toggleMobileMenu = useCallback(() => setIsMobileMenuOpen(!isMobileMenuOpen), [isMobileMenuOpen]);

  const toggleMobileMenuActiveItem = useCallback(
    (id: string) => {
      if (id === mobileMenuActiveItem) return setMobileMenuActiveItem(null);

      return setMobileMenuActiveItem(id);
    },
    [mobileMenuActiveItem],
  );

  const contextValuesWrapper = useMemo(
    () => ({
      isMobileMenuOpen,
      toggleMobileMenu,
      mobileMenuActiveItem,
      toggleMobileMenuActiveItem,
    }),
    [isMobileMenuOpen, toggleMobileMenu, mobileMenuActiveItem, toggleMobileMenuActiveItem],
  );

  return <HeaderContext.Provider value={contextValuesWrapper}>{children}</HeaderContext.Provider>;
}
